import React, { PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useLoggedInUser } from 'features/auth/hooks/useAuthData';
import { isAssessmentsPendoRoute } from 'features/assessments/pendo/assessmentsPendoUtils';
import { initializePendo } from './utils/pendoUtils';
import { setupPendoScript } from './utils/pendoScriptUtils';

export const PendoWrapper = ({ children }: PropsWithChildren) => {
  const user = useLoggedInUser();
  const { pathname } = useLocation();

  useEffect(() => {
    if (isAssessmentsPendoRoute(pathname)) return;

    setupPendoScript().catch((error) => {
      console.error('Error loading Pendo script on mount:', error);
    });
  }, [pathname]);

  useEffect(() => {
    if (isAssessmentsPendoRoute(pathname)) return;

    initializePendo(user?.id, user?.hospital.id);
  }, [user?.hospital.id, user?.id, pathname]);

  return <>{children}</>;
};
